import http from "plugins/axios";

export default {
  getUserList({ page, size, topUserId, userId, channelId, channelUserId, type, startTime, endTime, positionId, billType, coin, bizId, balanceType }) {
    const safeChannelId =
      channelId === undefined || channelId === null || channelId === "undefined"
        ? ""
        : channelId;
    return http.get({
      url: `/la/admin/channel/bill/list?page=${page}&size=${size}&type=${type}&topUserId=${topUserId || ""}&userId=${userId || ""}&channelUserId=${channelUserId || ""}&channelId=${safeChannelId}&startTime=${startTime || ""}&endTime=${endTime || ""}&positionId=${positionId || ""}&billType=${billType || ""}&coin=${coin || ""}&bizId=${bizId || ""}&balanceType=${balanceType || ""}`,
    });
  },

  exportExcel({ page, size, topUserId, userId, channelId, channelUserId, type, startTime, endTime, positionId, billType, coin, bizId, balanceType }) {
    const safeChannelId =
      channelId === undefined || channelId === null || channelId === "undefined"
        ? ""
        : channelId;
    return http.get({
      url: `/la/admin/channel/bill/list/excel?page=${page}&size=${size}&type=${type}&topUserId=${topUserId || ""}&userId=${userId || ""}&channelUserId=${channelUserId || ""}&channelId=${safeChannelId}&startTime=${startTime || ""}&endTime=${endTime || ""}&positionId=${positionId || ""}&billType=${billType || ""}&coin=${coin || ""}&bizId=${bizId || ""}&balanceType=${balanceType || ""}`,
      responseType: "blob",
    });
  },

  addRemark({ channelId, userId, remark }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remark=${remark}&userId=${userId}`,
    });
  },

  getDetail({ userId, coin }) {
    return http.get({
      url: `/channel/spot/detail?userId=${userId}&coin=${coin}`,
    });
  },

  getCoinList() {
    return http.get({
      url: "/la/admin/coin/list",
    });
  },

  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    });
  },
};
